import React from 'react';

import {BaseBlock, ContentActions, ContentOptions} from '../types';
import {ContentCard} from '../components';
import {COMMENT, FOR_END_STATEMENT} from './constants';

import './ForLoop.scss';
import {getForStartName} from './utils';


interface ForEndProps {
  content: BaseBlock;
  options?: ContentOptions;
  actions?: ContentActions;
}

export const ForEnd = ({
  content,
  actions,
}: ForEndProps) => {
  const uid = content.uid;
  /*
   * `useCreateBlock` handled in ForStart component
   * Deleting this block is taken care in the reducer based on `batchId`
   */

  return (
    <ContentCard
      key={content.id}
      type={content.type}
      contentId={uid}
      disabled={false}
      noContentElement={undefined}
      allowCollapse={false}
    >
      <div className="content__for-end">
        <div className="for-statement">
          <div className="for-statement__item">{FOR_END_STATEMENT}</div>
          <div className="for-statement__item comment">{COMMENT(getForStartName(content.name))}</div>
        </div>
      </div>
    </ContentCard>
  )
}

export default ForEnd;
